import React from 'react'
import styled from 'styled-components'
import { up } from 'styled-breakpoints'

import { useTrendingClubs } from '../../../../data/hooks/club'
import { DialogLevel, useDialog } from '../../dialog/hook'

import Loader from '../../loader'
import BookDialog from '../book'
import ColoredDialogBackdrop from '../colored-dialog-backdrop'

type TrendingBooksProps = {
    onOnboardingFinished: () => void
}

const TrendingBooks: React.FunctionComponent<TrendingBooksProps> = ({ onOnboardingFinished }) => {
    const {pending, data} = useTrendingClubs()
    const { setComponent } = useDialog()

    return (
        <Container>
            {
                data && <BookList>
                    { data.read.map(book => (
                        <Image 
                            src={book.image}
                            onClick={() => setComponent(
                                <BookDialog book={book} needsUpdate={true} onStatusUpdated={onOnboardingFinished}/>, 
                                <ColoredDialogBackdrop bg={"#A2ABBA"}/>, 
                                DialogLevel.Top
                            )}
                        >
                            { book.image ? '' : book.title}
                        </Image>
                    ))}
                </BookList>
            }
            { pending && <Loader />}
        </Container>
    )
}

const Container = styled.div`
    display: grid;
    grid-template-columns: 1fr;

    justify-items: center;

    height: 100%;
    width: 100%;

    ${up('desktop')} {
        height: fit-content;
        height: 70vh;
    }

    overflow-y: auto;
`

const BookList = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 32px;

    justify-items: center;

    height: 100%;
    width: 100%;

    ${up('desktop')} {
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
        grid-gap: 48px;
    }
`

const Image = styled.div<{ src: string | undefined }>`
    display: grid;
    align-items: center;
    justify-content: center;

    width: 100%;
    aspect-ratio: 6 / 9;
    border-radius: 10px;

    font-size: 16px;
    text-align: center;
    word-wrap: anywhere;

    background: ${ p => p.src ? `url("${p.src}")` : p.theme.colors.bg };
    background-size: cover;
    background-position: 50%;

    box-shadow: 0px 4px 24px #ABBAD3;

    cursor: pointer;
    overflow: hidden;
`

export default TrendingBooks